import {
  userStoreSelector,
  useUserStore,
} from '@repo/editor/src/stores/userStore';
import { withEventScope } from '@repo/event-processor';
import {
  Button,
  greySmallTheme,
  greyTheme,
  primarySmallTheme,
  primaryTheme,
} from '@repo/ui/components/Buttons';
import BookmarkIcon from '@repo/ui/components/Icon/BookmarkIcon';
import CopyIcon from '@repo/ui/components/Icon/CopyIcon';
import FilledBookmarkIcon from '@repo/ui/components/Icon/FilledBookmarkIcon';
import FilledHeartIcon from '@repo/ui/components/Icon/FilledHeartIcon';
import HeartIcon from '@repo/ui/components/Icon/HeartIcon';

import LinkButton from 'components/LinkButton/LinkButton';
import ResponsiveSpacer from 'components/ResponsiveSpacer/ResponsiveSpacer';
import { buildEditorUrlWithTemplateParams } from 'global/urlUtils';
import { LayoutSwitch } from 'styles/queries';

import { ActionButtonWrapper, RightButtonsWrapper } from './styles';
import ActionButtonsProps from './types';

/**
 * render the action buttons, to use and like a design
 */
const ActionButtons = ({
  post,
  likes,
  onLike,
  onUse,
  onBookmark,
  bookmarkLabel,
}: ActionButtonsProps) => {
  const user = useUserStore(userStoreSelector.user);
  const proAccess = useUserStore(userStoreSelector.proAccess);
  return (
    <ActionButtonWrapper>
      <LayoutSwitch
        desktopProps={{
          height: '40px',
          icon: { component: CopyIcon, height: '16px' },
          theme: primaryTheme,
          width: '232px',
          isButton:
            !user ||
            user?.designsLimitReached ||
            (post.template.premium && !proAccess),
        }}
        mobileProps={{
          height: '33px',
          icon: { component: CopyIcon, height: '14px' },
          width: '100%',
          theme: { ...primarySmallTheme, height: '33px' },
          isButton: true,
        }}
        width="100%"
      >
        <LinkButton
          buttonAction={onUse}
          dataTestId="design-post--use-button"
          href={buildEditorUrlWithTemplateParams({
            id: post.template.id,
          })}
          isCentered={false}
          label={
            <>
              Use This Design
              <span className="popularity">{post.template.popularity}</span>
            </>
          }
          target="_blank"
        />
      </LayoutSwitch>
      <RightButtonsWrapper>
        <LayoutSwitch
          desktopProps={{
            height: '40px',
            theme: greyTheme,
            width: 'min-content',
          }}
          mobileProps={{
            height: '33px',
            theme: { ...greySmallTheme, height: '33px' },
            width: '100%',
          }}
          width="100%"
        >
          <Button
            dataTestId="design-post--like-button"
            disabled={likes.status === 'pending'}
            icon={{
              component: likes.likedByUser ? FilledHeartIcon : HeartIcon,
              height: '14px',
            }}
            label={`${likes.total}`}
            name="likeDesignPostButton"
            onClick={onLike}
          />
        </LayoutSwitch>
        <ResponsiveSpacer dw="12px" mw="8px" />
        <LayoutSwitch
          desktopProps={{
            height: '40px',
            theme: greyTheme,
            width: 'min-content',
          }}
          mobileProps={{
            height: '33px',
            theme: { ...greySmallTheme, height: '33px' },
            width: '100%',
          }}
          width="100%"
        >
          <Button
            dataTestId="design-post--bookmark-button"
            icon={{
              component:
                bookmarkLabel === 'Bookmarked'
                  ? FilledBookmarkIcon
                  : BookmarkIcon,
            }}
            label={bookmarkLabel}
            name="designPostBookmarkButton"
            onClick={onBookmark}
          />
        </LayoutSwitch>
      </RightButtonsWrapper>
    </ActionButtonWrapper>
  );
};

export default withEventScope(ActionButtons, { module: 'actionButtons' });
